import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Phone, Mail, MapPin, Calendar, Instagram } from 'lucide-react';
import SEO from '../components/SEO';

const Contact = () => {
  return (
    <main className="pt-24 bg-[#FDFDFB]">
      <SEO 
        title="Contact Us"
        description="Get in touch with Harmony Behavioral & Psychiatric Health. Call 404-738-7542 or visit us at 1123 Clairmont Rd, Decatur, GA 30030."
        keywords="contact psychiatrist, book appointment, mental health contact, Decatur GA psychiatrist"
      />

      <section className="py-16 bg-gradient-to-b from-[#f7f4f0] to-[#FDFDFB]">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h1 className="text-5xl font-bold text-[#7a8a72] mb-6">Contact Us</h1>
            <p className="text-xl text-[#3a3a3a]">
              We're here to support you on your mental health journey
            </p>
          </div>

          <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8">
            <Card className="p-8 bg-white border-[#d4cec5]">
              <h2 className="text-2xl font-bold text-[#7a8a72] mb-6">Get in Touch</h2>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <Phone className="text-[#7a8a72] flex-shrink-0 mt-1" size={24} />
                  <div>
                    <p className="font-semibold text-[#3a3a3a]">Phone</p>
                    <a href="tel:404-738-7542" className="text-[#7a8a72] hover:underline">
                      404-738-7542
                    </a>
                    <p className="text-sm text-[#3a3a3a] mt-1">Call or text</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <Mail className="text-[#7a8a72] flex-shrink-0 mt-1" size={24} />
                  <div>
                    <p className="font-semibold text-[#3a3a3a]">Fax</p>
                    <p className="text-[#3a3a3a]">678-737-1486</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <MapPin className="text-[#7a8a72] flex-shrink-0 mt-1" size={24} />
                  <div>
                    <p className="font-semibold text-[#3a3a3a]">Address</p>
                    <p className="text-[#3a3a3a]">1123 Clairmont Rd</p>
                    <p className="text-[#3a3a3a]">Decatur, GA 30030</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <Instagram className="text-[#7a8a72] flex-shrink-0 mt-1" size={24} />
                  <div>
                    <p className="font-semibold text-[#3a3a3a]">Social Media</p>
                    <a
                      href="https://instagram.com/harmonyhealthwell"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#7a8a72] hover:underline"
                    >
                      @harmonyhealthwell
                    </a>
                  </div>
                </div>
              </div>
            </Card>

            <Card className="p-8 bg-[#7a8a72] text-white">
              <h2 className="text-2xl font-bold mb-6">Book an Appointment</h2>
              <p className="mb-6">
                Ready to start your journey toward mental wellness? Schedule your appointment today.
              </p>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <Calendar className="flex-shrink-0 mt-1" size={20} />
                  <p className="text-sm">Select your preferred appointment time</p>
                </div>
                <div className="flex items-start gap-3">
                  <Calendar className="flex-shrink-0 mt-1" size={20} />
                  <p className="text-sm">Choose between insured or self-pay options</p>
                </div>
                <div className="flex items-start gap-3">
                  <Calendar className="flex-shrink-0 mt-1" size={20} />
                  <p className="text-sm">Complete intake paperwork before your visit</p>
                </div>
              </div>
              <Link to="/book-appointment" className="block mt-6">
                <Button size="lg" className="w-full bg-[#c9b17a] hover:bg-[#b89d66] text-white rounded-lg">
                  Now Accepting New Clients — Book Today
                </Button>
              </Link>
            </Card>
          </div>

          <Card className="mt-8 max-w-5xl mx-auto p-8 bg-white border-[#d4cec5] text-center">
            <h3 className="text-2xl font-bold text-[#7a8a72] mb-4">Office Hours</h3>
            <p className="text-[#3a3a3a]">
              We offer flexible telehealth appointment times to accommodate your schedule.
            </p>
            <p className="text-[#3a3a3a] mt-2">
              Please call or book online to see available appointment times.
            </p>
          </Card>
        </div>
      </section>
    </main>
  );
};

export default Contact;